import requests from '@/utils/requests';

/**
 * 需求开发时间排名
 * @param {*} data
 */
export function reqDevTimeRank(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/devTimeRank',
    method: 'post',
    data
  });
}

/**
 * 需求开发时间排名
 * @param {*} data
 */
export function reqAddRemTrend(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/verReqTrend',
    method: 'post',
    data
  });
}

